export const STATIC_VARIABLES = {
  ADMINID: "IVfLu08KT8NVeME0ZKgk",
  ROUTEPARTNERID: "611153",
};
